import React from 'react'
import ProductDetails from '../features/products/ProductDetails'

export default function ProductPage() {
  return (
    <>
    <ProductDetails/>
    </>
  )
}
